export function openInNewTab(url){
  if(!url) return;

  // open a new tab
  let win = window.open();

  // this is for security reasons
  win.opener = null;
  win.referrer = null;

  // point the new tab at the url and focus
  win.location = url;
  win.focus();
}

export function publicUrl(url){
  return process.env.PUBLIC_URL + '/' + url;
}

export function groupBy(xs, key) {
  return xs.reduce(function(rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};
